import { render, staticRenderFns } from "./CouponPendingLink.vue?vue&type=template&id=d3edcf64&scoped=true"
import script from "./CouponPendingLink.vue?vue&type=script&lang=js"
export * from "./CouponPendingLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3edcf64",
  null
  
)

export default component.exports